import React from "react";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { Sex, Reproduction } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  sex: string;
  value: string;
  onChange: (reproduction: string) => void;
};

export function ReproductionQuestion({ dogName, sex, value, onChange }: Props) {
  const isMale = sex === Sex.MALE;
  const question = isMale ? "neutered" : "spayed";
  const yesValue = isMale ? Reproduction.NEUTERED : Reproduction.SPAYED;
  const noValue = isMale ? Reproduction.NOT_NEUTERED : Reproduction.NOT_SPAYED;

  const OPTIONS: ChoiceOption[] = [
    { value: yesValue, label: "Yes", icon: quizAsset("icon-yes") },
    { value: noValue, label: "No", icon: quizAsset("icon-no") },
  ];

  return (
    <QuestionCard
      title={`Is ${dogName || "your dog"} surgically ${question}?`}
      field="reproduction"
    >
      <QuizChoiceCard options={OPTIONS} selected={value} onSelect={onChange} />
    </QuestionCard>
  );
}
